export const LEAD_EVENT_TYPES = [
  "lead.created",
  "lead.first-message-sent",
  "lead.first-message-delivered",
  "lead.first-message-read",
  "lead.first-message-answered",
  "lead.redirected-to-human",
  "lead.appointment-intention",
  "lead.appointment-created",
  "lead.inactivated",
  "lead.discarded",
  "lead.call-ended",
  "lead.property-info-collected",
  "lead.maintenance-requested",
] as const;

export const RENTALS_TYPES = [
  { id: "rentLiving", name: "Arriendo de propiedades residenciales" },
  { id: "rentBusiness", name: "Arriendo de propiedades comerciales" },
  { id: "sale", name: "Venta" },
  { id: "general", name: "Administrativo" },
  { id: "default", name: "Default" },
] as const;

export type LeadEventType = (typeof LEAD_EVENT_TYPES)[number];
export type RentalsType = (typeof RENTALS_TYPES)[number]["id"];

export type ProjectWithConfig = {
  id: string;
  name: string;
  crmConfiguration?: {
    id: string;
    pipelineId?: number | string;
    pipelineName?: string;
    pipedriveEventsMapping?: unknown[];
    smarthomeEventsMapping?: unknown[];
  };
};

export type RentalsTypeWithConfig = {
  id: RentalsType;
  name: string;
  crmConfiguration?: {
    id: string;
    pipelineId?: number | string;
    pipelineName?: string;
    pipedriveEventsMapping?: unknown[];
    smarthomeEventsMapping?: unknown[];
    transferCategories?: string[];
  };
};

export type ItemWithConfig = ProjectWithConfig | RentalsTypeWithConfig;
